/**
 * 企画書データ出力画面　企画書データ出力検索条件VOクラス
 */
export class KYMW1301CatalogDataCsvModel {

  public orderCodeFrom: string = null;                                          // 受注コード(From)
  public orderCodeTo: string = null;                                            // 受注コード(To)
  public pCode: string = null;                                                  // Ｐコード
  public mediumType: string = null;                                             // 媒体区分
  public coopCode: string = null;                                               // 生協コード
  public pageNumFrom: string = null;                                            // 出力開始ページ
  public pageNumTo: string = null;                                              // 出力終了ページ
  public orderNum: string = null;                                               // 注文コード
  public featureCode: string = null;                                            // 特集コード
  public markCode1: string = null;                                              // マークコード1
  public markCode2: string = null;                                              // マークコード2
  public markCode3: string = null;                                              // マークコード3
  public markCode4: string = null;                                              // マークコード4
  public markCode5: string = null;                                              // マークコード5
  public wPublishFlag: string = null;                                           // Ｗ掲載除外フラグ
  public multiPublishFlag: string = null;                                       // Ｗ掲載フラグ
  public classificationsList: Array<any> = new Array<any>();                    // 部門コードリスト

}
